// import { UserAgentApplication } from 'msal';
import { ONE_DRIVE_API, ONE_DRIVE_CONFIG, getFileNameWithExtension, SUPPORT_FILE_MIME_TYPES, setDriveTokenInfo, ONE_DRIVE} from './drives.constants';
import axios from 'axios';
//import qs from 'qs';
import { store } from 'Store/store.index';
import { baseUrlApis } from './index';
import { apiRetryFunc, convertUTCToLocale, getFileSize, handlerFileNameWithoutExtension, mimeMap, prop, storageGetItem, storageRemoveItem, storageSetItem, windowActionFn } from 'Utils/utils';
import intl from 'react-intl-universal';
import { HttpRequest } from './request.utils'

// UserAgentApplication.prototype.logout = function() {
//   var _this = this;
//   this.clearCache();
//   this.account = null;
//   var logout = '';
//   var logoutUri = baseUrlApis.getBaseUrl() + 'logout/success';

//   logout = 'post_logout_redirect_uri=' + encodeURIComponent(logoutUri);

//   this.authorityInstance.resolveEndpointsAsync().then(function(authority) {
//     var urlNavigate = authority.EndSessionEndpoint ? authority.EndSessionEndpoint + '?' + logout : _this.authority + 'oauth2/v2.0/logout?' + logout;
//     var popupWindow = _this.openWindow('about:blank', '_blank', 1, _this, null, null);
//     _this.navigateWindow(urlNavigate, popupWindow);
//   });
// };

export default class OneDriveApi extends HttpRequest {
  constructor() {
    super();
    this.downloadFileRequest = false;
    this.uploadFileRequest = false;
    this.CancelToken = axios.CancelToken;
    this.cancelDownloadFileFn = null;
    this.cancelUploadFileFn = null;
    // this.userAgentApplication = null;
    this.oneDriveAxios = null;
    this.serverUrl = null;

    this.init();
  }

  init() {
    ONE_DRIVE_CONFIG.INIT_CONFIG();
    this.serverUrl = getSharePointNodeServer()
    this.oneDriveAxios = axios.create({
      baseURL: ONE_DRIVE_API.BASEURL,
    });
    super.initialize(this.oneDriveAxios, () => {
      let requestCfg = {
        success: (config) => {
          store.driveStore.numberOfAjaxCAllPendingIncrease();
          let accessToken = storageGetItem(localStorage, 'OneDriveAccessToken');
          if (accessToken) {
            config.headers = {
              Authorization: `Bearer ${accessToken}`,
              ...config.headers,
            };
          }

          return config;
        },
        error: (error) => {
          return Promise.reject(error);
        }
      }
      let responseCfg = {

        success: (res) => {
          store.driveStore.numberOfAjaxCAllPendingDecrease();

          return res.data;
        },
        error: (error) => {
          store.driveStore.numberOfAjaxCAllPendingDecrease();

          this.errorHandler(error);

          return Promise.reject(error);
        },
      }
      this.interceptorsProxyFn(requestCfg, responseCfg);
    });

  }
  async errorHandler(error) {
    let errorMsg;
    const { errorCode, response } = error;

    if (error.__CANCEL__) {
      errorMsg = intl.formatMessage({ id: 'CancelRequest' });
    } else if (errorCode === 'user_login_error') {
      error.autoSignOut = true;
      errorMsg = intl.formatMessage({ id: 'InvalidToken' });
    } else if (error && error.message.indexOf('401') > -1) {
      const { sharePointInfo: { isFromSharePoint } } = store.appStore

      if (isFromSharePoint) {
        try {
          await apiRetryFunc(store.driveStore.sharePointRefreshTokenHandler, 3, 1000)
          await store.driveStore.saveFileBackToDrive()

          return
        } catch (error) {
          error.autoSignOut = true;
          errorMsg = intl.formatMessage({ id: 'DrivesListDlg.ReacquireTokenFailed' });
          throw error
        }
      }

      error.autoSignOut = true;
      errorMsg = intl.formatMessage({ id: 'DrivesListDlg.TokenExpire' });
    } else if (error.message === 'Network Error') {
      errorMsg = intl.formatMessage({ id: 'NetworkError' });
    } else if (
      response &&
      response.status === 403 &&
      response.data.error.message === 'You do not have access to create this personal site or you do not have a valid license'
    ) {
      error.autoSignOut = true;
      errorMsg = intl.formatMessage({ id: 'Error.NoLicense' });
    } else if(
      response &&
      response.status === 403 &&
      response.data.error.code === "accessDenied"
    ){
      errorMsg = intl.formatMessage({ id: 'Error.PermissionDenied' });
      store.appStore.showLoading(false)
    } else if (response && response.status === 404) {
      errorMsg = intl.formatMessage({ id: 'FileNotExist' });
    }else {
      error.autoSignOut = true;
      errorMsg = intl.formatMessage({ id: 'Error.SignOutAndRetry' });
    }

    if (error.autoSignOut) {
      this.signOut()
    }

    store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });
  }
  signOut(success) {
    storageRemoveItem(localStorage, 'OneDriveAccessToken');
    success && success();
  }
  signIn(success, closeWin) {
    let left = window.innerWidth / 2 - 300;
    let _hTime = null;
    let _hWin = windowActionFn(window, 'open', [ONE_DRIVE_CONFIG.AUTHORIZATION_URL(), 'OneDriveAuthorizationWin', `width=600, height=645, left=${left}, top=240`]);

    function onSignSuccess(token) {
      storageSetItem(localStorage, 'OneDriveAccessToken', token); //"null"
      success && success();
    }
    function onHandleWindowMessage(event) {
      let origin = baseUrlApis.getBaseUrl();

      if (event.data.oneDriveCode && `${event.origin}/` === origin) {
          onSignSuccess(event.data.oneDriveCode);
      }
    }
    function onHandleStorage(e) {
      if (e.key === 'oneDriveCode') {
        onSignSuccess(e.newValue);
        clean();
      }
    }
    function clean() {
      if (!_hWin) {

        return;
      }
      _hWin.close();
      _hWin = null;
      closeWin && closeWin()
      _hTime && clearInterval(_hTime);
      _hTime = null;
      window.removeEventListener('message', onHandleWindowMessage);
      window.removeEventListener('storage', onHandleStorage);
    }
    // start to listen
    _hTime = setInterval(() => {
      if (!!_hWin&&_hWin.closed) {

        clean();
      }
    }, 2000);

    window.addEventListener('message', onHandleWindowMessage, false);
    window.addEventListener('storage', onHandleStorage, false);
  }
  getUserInfo(success, fail) {
    this.get({
      url: ONE_DRIVE_API.GET_USER_INFO,
    })
      .then((res) => {
        let accessToken = storageGetItem(localStorage, 'OneDriveAccessToken');

        res.userAccount = res.userPrincipalName;
        res.accessToken = accessToken
        setDriveTokenInfo(ONE_DRIVE, res.userAccount)
        success && success(res);
      })
      .catch((error) => {
        fail && fail(error);
      });
  }
  async downloadFile(item, success, fail) {

    this.downloadFileRequest = true;

    //ONLINERD-2052  onedrive business: Failed to open file
    let _self = this;
    let downloadUrl = item['@microsoft.graph.downloadUrl'];
    if (downloadUrl.indexOf('.sharepoint.com/') !== -1) {
      var createCORSRequest = function(method, url) {
        var xhr = new XMLHttpRequest();
        if ("withCredentials" in xhr) {
          // Most browsers.
          xhr.open(method, url, true);
          xhr.responseType = 'blob';
        } else if (typeof XDomainRequest != "undefined") {
          // IE8 & IE9
          xhr = new XDomainRequest();
          xhr.open(method, url);
          xhr.responseType = 'blob';
        } else {
          // CORS not supported.
          xhr = null;
        }
        return xhr;
      };
      var url = downloadUrl;
      var method = 'GET';
      var xhr = createCORSRequest(method, url);
      xhr.onload = function() {
        _self.downloadFileRequest = false;
        success && success({ blob: xhr.response, id: item.id, fileName: item.name });
      };
      xhr.onerror = function(error) {
        _self.downloadFileRequest = false;
        fail && fail(error);
      };
      xhr.send();
      return;
    }

    this.get({
      url: item['@microsoft.graph.downloadUrl'],
      config:{
        responseType: 'blob',
        cancelToken: new this.CancelToken((c) => {
          // An executor function receives a cancel function as a parameter
          this.cancelDownloadFileFn = c;
        }),
      }
    })
      .then((data) => {
        this.downloadFileRequest = false;
        success && success({ blob: data, id: item.id, fileName: item.name });
      })
      .catch((error) => {
        this.downloadFileRequest = false;

        fail && fail(error);
      });
  }
  cancelDownloadFile() {
    this.cancelDownloadFileFn && this.cancelDownloadFileFn();
  }
  async getItems(folderId, success, fail) {
      let handleItems = (res) => {
        let folders = [];
        let files = [];

        res.result = {};
        res.value.forEach((item) => {
          item.modifiedTime = convertUTCToLocale(item.lastModifiedDateTime);
          item.createdDateTime = convertUTCToLocale(item.createdDateTime);

          if (item.folder) {
            item.size = '';
            item.modifiedTime = ''
            item.isFolder = true;
            folders.push(item);
          }
          if (item.file && SUPPORT_FILE_MIME_TYPES.indexOf(item.file.mimeType) > -1) {
            item.name = getFileNameWithExtension(item.name, item.file.mimeType)
            item.originSize = item.size
            item.size = getFileSize(item.size);
            files.push(item);
          }
        });

        const { saveType } = store.driveStore

        if (saveType) {
          const targetMimeType = mimeMap[saveType]

          files = files.filter((item) => {
            return item.file.mimeType === targetMimeType
          })
        }

        res.result.files = [...folders, ...files];

        success && success(res);
      };

      folderId
        ? this.get({
          url: `${ONE_DRIVE_API.GET_FILES}/${folderId}/children?orderby=name asc`,
        })
          .then((res) => {
            handleItems(res);
          })
          .catch((error) => {
            fail && fail(error);
          })
        : this.get({
          url: `${ONE_DRIVE_API.GET_ROOT_FILES}?orderby=name asc`,
        })
          .then((res) => {
            handleItems(res);
          })
          .catch((error) => {
            fail && fail(error);
          });
  }
  updateFile(fileId, file, success, fail, progress) {
    this.put({
      url: `${ONE_DRIVE_API.UPDATE_FILE}/${fileId}/content`,
      data: file,
      config:{
        onUploadProgress: function (progressEvent) {
          if (progressEvent.lengthComputable) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

            progress && progress(percentCompleted);
          }
        },

      }
    })
      .then(() => {
        success && success();
      })
      .catch((error) => {
        fail && fail(error);
      });
  }
  async uploadFileToSharepoint({fileBlob}) {
    return new Promise((resolve, reject) => {
      this.createFileWithUploadSession(fileBlob, null, resolve, reject, null, true)
    })
  }
  async createFileWithUploadSession(file, folderPath, success, fail, progress, isSharepoint) {
        let url
        let folderPathStr = 'root:';
        const headers = {
          'Content-Type': 'application/json',
        }

        // 从office file handler跳转到online
        if (isSharepoint) {
          const fileName = file.name || 'untitled.pdf'
          const { fileHandlerToken, sharepointFilesInfoArr } = store.driveStore
          const { path } = sharepointFilesInfoArr[0].parentReference
          
          url = ONE_DRIVE_API.UPLOAD_FILE_TO_SHAREPOINT({ fileName, path })

          fileHandlerToken && Object.assign(headers, {
            Authorization: `Bearer ${fileHandlerToken}`,
          })
        } else {
          folderPath &&
          folderPath.forEach((element, index) => {
            if (index !== 0) {
              folderPathStr += `/${element.name}`;
            }
          });
          
          url = `${ONE_DRIVE_API.CREATE_FILE}/${folderPathStr}/${handlerFileNameWithoutExtension(file.name)}:/createUploadSession`
        }

        this.post({
          url,
          data: {
            item: {
              '@microsoft.graph.conflictBehavior': 'replace',
            },
          },
          config:{
            headers,
          }
        })
          .then((res) => {
            this.uploadFileRequest = true;
            this.put({
              url: res.uploadUrl,
              config: {
                headers: {
                  // 'Content-Length': file.size,
                  'Content-Range': `bytes 0-${(file.size - 1)}/${file.size}`,
                },
                onUploadProgress: function (progressEvent) {
                  if (progressEvent.lengthComputable) {
                    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

                    progress && progress(percentCompleted);
                  }
                },
                cancelToken: new this.CancelToken((c) => {
                  // An executor function receives a cancel function as a parameter
                  this.cancelUploadFileFn = c;
                }),
              },
              data: file,
            })
              .then((res) => {
                this.uploadFileRequest = false;
                success && success(res);
              })
              .catch((error) => {
                this.uploadFileRequest = false;

                fail && fail(error);
              });
          })
          .catch((error) => {
            fail && fail(error);
          });
  }

  createFolder({folderName, folderPath}) {
    let folderPathStr = 'root';
    const data = JSON.stringify({
      name: folderName,
      folder: { },
      '@microsoft.graph.conflictBehavior': 'rename'
    })

    if (folderPath.length > 1) {
      folderPathStr = [...folderPath].reverse()[0].id
    }
    
    return this.post({
      url: `${ONE_DRIVE_API.CREATE_FILE}/${folderPathStr}/children`,
      config: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
      data,
    })
  }
  async createFile(file, folderPath, success, fail, progress) {
        let folderPathStr = 'root:';

        folderPath &&
          folderPath.forEach((element, index) => {
            if (index !== 0) {
              folderPathStr += `/${element.name}`;
            }
          });

        this.uploadFileRequest = true;

        this.put({
          url: `${ONE_DRIVE_API.CREATE_FILE}/${folderPathStr}/${handlerFileNameWithoutExtension(file.name)}:/content`,
          config: {
            params: {
              '@microsoft.graph.conflictBehavior': 'replace',
            },
            onUploadProgress: function(progressEvent) {
              if (progressEvent.lengthComputable) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

                progress && progress(percentCompleted);
              }
            },
            cancelToken: new this.CancelToken((c) => {
              // An executor function receives a cancel function as a parameter
              this.cancelUploadFileFn = c;
            }),
          },
          data: file,
        })
          .then(() => {
            this.uploadFileRequest = false;
            success && success();
          })
          .catch((error) => {
            this.uploadFileRequest = false;

            fail && fail(error);
          });
  }
  cancelUploadFile() {
    this.cancelUploadFileFn && this.cancelUploadFileFn();
  }
  isSignIn() {
    const inTeams = store.teamsAppStore.inTeamsApp
    if (inTeams) {

    } else {
      let accessToken = storageGetItem(localStorage, 'OneDriveAccessToken');

      if (accessToken) {
        return true;
      } else {
        return false;
      }
    }
  }

  getOneDriveFileByUrl(shareUrl,success,fail){

    this.get({
      url: `${ONE_DRIVE_API.BASEURL}/shares/${shareUrl}/driveItem`,
      config: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    })
    .then((result) => {

      this.uploadFileRequest = false;
      // this.downloadFile(result,success);
      success && success(result);
    })

    .catch((error) => {
      console.error("getOneDriveFileByUrl -> error", error);
      this.uploadFileRequest = false;

      fail && fail(error);
    });

  }
  getFileFromFileHandler(url, token) {
    return this.get({
      url,
      config:  {
        headers: {
          "Authorization": `Bearer ${token}`,
        }
      },
    });
  }
  getFileHandlerState({stateId, refreshTokenId, accessTokenId}) {
    const url = `${this.serverUrl}api/auth/getState`

    return axios.get(url, {
      params: {
        stateId,
        refreshTokenId,
        accessTokenId
      }
    });
  }
  async refreshTokenForSharePoint(refreshTokenInfo) {
    const url = `${this.serverUrl}api/auth/getTokenByRefreshToken`
    
    return axios.get(url, {
      params: {
        refreshTokenInfo: JSON.stringify(refreshTokenInfo)
      }
    });
  }
  webHookSubscribeForSharePoint() {
    let url 
    const { fileHandlerToken } = store.driveStore
    const { parentReference: { driveId }, id } = store.driveStore.sharepointFilesInfoArr[0]
    
    if (prop(location, "host").indexOf('localhost') > -1) {
      url = "http://localhost:3333/delegated/subscribe";
    } else {
      url = `${location.origin}/webhook/delegated/subscribe`;
    }

    return axios.get(url, {
      params: {
        accessToken: fileHandlerToken,
        resourcePath: `/drives/${driveId}/root`,
        clientState: id,
      }
    })
  }
  getFileMetaData({driveId, itemId}) {
    const { fileHandlerToken: accessToken } = store.driveStore
    
    return this.get({
      url: `${ONE_DRIVE_API.BASEURL}/drives/${driveId}/items/${itemId}`,
      config: {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    });
  }
}

function getSharePointNodeServer() {
  let serverUrl
  const currentHost = prop(location, "host")

  if (currentHost.indexOf('localhost') > -1) {
    serverUrl = "https://localhost:4000/";
  } else if (currentHost.indexOf('.foxitcloud.com') > -1 || currentHost.indexOf('.connectedpdf.com') > -1) {
    serverUrl = "https://online-azk8s.foxitcloud.com/onedrive/"
  } else if (currentHost.indexOf('.foxit.com') > -1) {
    serverUrl = "https://pdfonline.foxit.com/onedrive/"
  }

  return serverUrl
}